import Vue from "vue";
import Router from "vue-router";
import { Auth } from "aws-amplify";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/survey/:id?",
      name: "survey",
      component: () => import("./views/HealthAssessmentSurvey.vue"),
    },
    {
      path: "/company-survey/:id?",
      name: "companysurvey",
      component: () => import("./views/CompanySurvey.vue"),
    },
    // {
    //   path: "/company-contact-survey/:id?",
    //   name: "companycontactsurvey",
    //   component: () =>
    //     import(/* webpackChunkName: "about" */ "./views/CompanyContactSurvey.vue")
    // },
    {
      path: "/workshop/:id?",
      name: "surveyworkshop",
      component: () => import("./views/WorkshopSurvey.vue"),
    },
    {
      path: "/coaching/:id?",
      name: "surveycoaching",
      component: () => import("./views/CoachingSurvey.vue"),
    },
    {
      path: "/voucher/:id?",
      name: "digitalvoucher",
      component: () => import("./views/DigitalVoucherSurvey.vue"),
    },
    {
      path: "/",
      name: "workshop",
      component: () => import("./views/Workshop.vue"),
      meta: { requiresAuth: true, role: ["ADMIN", "SERVICE"] },
    },
    {
      path: "/coachingsurvey",
      name: "coaching",
      component: () => import("./views/Coaching.vue"),
      meta: { requiresAuth: true, role: ["ADMIN", "SERVICE"] },
    },
    {
      path: "/login",
      name: "login",
      component: () => import("./views/Login.vue"),
    },
    {
      path: "/thankyou",
      name: "thankyou",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Thankyou.vue")
    }
  ],
  mode: "history",
});

router.beforeResolve((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    let user;
    Auth.currentAuthenticatedUser()
      .then((data) => {
        if (data && data.signInUserSession) {
          user = data;
          if (typeof to.meta.role !== "undefined") {
            // Roles
            let userRoles =
              user.signInUserSession.accessToken.payload["cognito:groups"];
            let role = to.meta.role;
            let authorised = false;
            userRoles.forEach(function(userRole) {
              if (role.includes(userRole)) {
                authorised = true;
              }
            });
            if (!authorised) {
              next({ path: "/login" });
            }
          }
        }
        next();
      })
      .catch(() => {
        next({ path: "/login" });
      });
  }
  next();
});

export default router;
